<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('menu.sewers')"/>
        <div class="col-12 nopads mt-2">
            <!-- Tabs -->
            <ul class="nav nav-tabs routa-tabs">
                <li class="nav-item routa-tab-nav-item">
                    <button class="routa-tab" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
                        {{ $t('menu.sewer_drains') }}
                    </button>
                     </li>
                <li class="nav-item">
                    <button class="routa-tab" :class="{ active: activeTab === 2 }" @click="activeTab = 2">
                        {{  $t('menu.sewer_lines')  }}
                    </button>
                     </li>
            </ul>
            <!-- Content -->
            <div class="tab-content routa-tab-content">
                <div class="tab-pane fade" :class="{ show: activeTab === 1, active: activeTab === 1 }">
                    <storm-sewer-drains :user="user" />
                </div>
                <div class="tab-pane fade" :class="{ show: activeTab === 2, active: activeTab === 2 }">
                    <storm-sewer-lines :user="user" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from "@/components/utils/Navbar";
import ConversionTaskTypeModels from "@/components/tasktype/conversion/ConversionTaskTypeModels";
import ConversionModels from "@/components/pricingmodels/conversion/ConversionModels";
import StormSewerLines from "@/components/stormsewers/StormSewerLines";
import StormSewerDrains from "@/components/stormsewers/StormSewerDrains";

export default {
    name: 'StormSewers',
    components: {
        StormSewerDrains,
        StormSewerLines,
        ConversionModels,
        ConversionTaskTypeModels,
        Navbar
    },
    props: {
        user: {
            type: Object
        }
    },
    data: function () {
        return {
            activeTab: 1,
        }
    }
}
</script>
